import { client } from 'api';
import * as types from '../../mutationTypes';

export default {
    async get({ commit }) {
        let parentData = { data: null };
        const clientData = await client.getClient();
        if (clientData.data.parentId) { parentData = await client.getClientParent(); }
        const childrenData = await client.getClientChildren();
        commit(types.UPDATE_CLIENT, {
            ...clientData.data,
            parent: parentData.data,
            children: childrenData.data
        });
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/client/actions.js